<div class="billing-documents-bulk-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <div class="col-md-12">
        <span class="pull-left text-purple-manax subtitle-section mr-2 mt-2">Fecha:</span>
        <span class="pull-left mr-2">
          <input type="date" class="filter small" [(ngModel)]="filter.filters.dateStart"
            (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
            style="max-width: 120px; margin-top:9px" />
        </span>
        <span class="text-purple-manax pull-left subtitle-section mr-2 mt-2">&nbsp;a&nbsp;</span>
        <span class="pull-left mr-2">
          <input type="date" class="filter small" [(ngModel)]="filter.filters.dateEnd"
            (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
            style="max-width: 120px; margin-top:9px" />
        </span>
        <span class="pull-left mr-4">
          <button class="btn btn-manax" (click)="generateZipFile()">
            <i class="material-icons">download</i> Generar Zip
          </button>
        </span>
        <span class="pull-left mr-4">
          <button class="btn btn-manax" (click)="downloadExcelFile()">
            <i class="material-icons">download</i> Descargar Excel
          </button>
        </span>
      </div>
    </div>

    <!-- body -->
    <div class="row">
      <div class="col-12">
        <h3>&nbsp;&nbsp; Histórico </h3>
        <ul *ngFor="let file of files">
          <li>Fecha de creación: <a href="{{file.fileUrl}}" target="_blank">
              {{file.createdAt | date:'dd/MM/yyyy HH:mm'}}</a></li>
        </ul>
      </div>
    </div>
  </div>